import { Button, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import "firebase/firestore";
import _ from "lodash";
import * as React from "react";
import { useEffect, useState } from "react";
import { getOrders, nbfInventoryByDate } from "../../api/restApi";
import OverlayLoader from "../../components/modals/OverlayLoader";
import { ordersData } from "../../store/reducer/ordersSlice";
import { productsData } from "../../store/reducer/productsSlice";
import { ConvertOrderArrayToObject } from "../../utils/helpers";
import { useAppSelector } from "../../utils/hooks";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ReactToPrint from "react-to-print";

export default function DashboardDailySheet() {
  const isMediumScreen = useMediaQuery("(min-width: 960px)");
  const [category, setCategory] = useState([]);
  const [type, setType] = useState([]);
  const [orderByCustomer, setOrderByCustomer] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedType, setSelectedType] = useState("All");
  const [openLoader, setOpenLoader] = useState(false);
  const [orderPlaced, setOrderPlaced] = useState();
  const [orderProduced, setOrderProduced] = useState();
  const [orderReturn, setOrderReturn] = useState("");
  const [productInfo, setProductInfo] = useState([]);
  const [filteredProductInfo, setFilteredProductInfo] = useState([]);
  const { products } = useAppSelector(productsData);
  const [orderDetails, setOrderDetails] = useState({
    productionAmount: 0,
    totalSale: 0,
    supplySale: 0,
    fpsSale: 0,
    otherUseAmount: 0,
    lastDayOnHandAmount: 0,
    todayOnHandAmount: 0,
  });
  const componentRef = React.useRef();
  const { ordersDate } = useAppSelector(ordersData);
  const sortedOrdersDate = [...ordersDate].sort(
    (a, b) => new Date(b) - new Date(a)
  );

  const [selectedDate, setSelectedDate] = useState(sortedOrdersDate[0]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    flexGrow: 1,
  }));

  async function callData(date) {
    try {
      setOpenLoader(true);
      let inventory = await nbfInventoryByDate(date);
      let response = await getOrders(date);
      let data = ConvertOrderArrayToObject(response);
      let products = _.sortBy(data.orders_product, "id");
      const merged = [
        ...inventory
          .concat(products)
          .reduce(
            (m, o) =>
              m.set(o.id + "", Object.assign(m.get(o.id + "") || {}, o)),
            new Map()
          )
          .values(),
      ];
      // sort merged with id
      merged.sort((a, b) => a.id - b.id);

      let productInfoArray = [];
      productInfoArray = [
        ...merged.map((element) => {
          return {
            ...findProduct(element.id),
            ...element,
            onHandEnd:
              element.production +
              element.onHandStart -
              (element.dispatch + element.fpsDispatch + element.otherUse),
          };
        }),
      ];
      setProductInfo([...productInfoArray]);
      setFilteredProductInfo([...productInfoArray]);

      let orderCategory = [];
      const groups = _.groupBy(productInfoArray, "category_english");
      Object.entries(groups).map(([key, value]) => {
        orderCategory.push(key);
      });

      setCategory([...orderCategory]);

      // let orderType = [];
      // const TypeGroups = _.groupBy(productInfoArray, "type_english");
      // Object.entries(TypeGroups).map(([key, value]) => {
      //   orderType.push(key);
      // });

      // setType([...orderType]);
      setOpenLoader(false);
    } catch {
      setOpenLoader(false);
    }
  }
  const findProduct = (id) => {
    return products.find((el) => el.id.toString() === id.toString());
  };
  const handleSelectDate = async (event, newValue) => {
    setSelectedDate(newValue);
    setSelectedCategory("All");
    setSelectedType("All");
    setProductInfo([]);
    callData(newValue);
  };

  const handleSelectCagegory = async (event, newValue) => {
    setSelectedCategory(newValue);
    setSelectedType("All");
  };

  const handleSelectType = async (event, newValue) => {
    setSelectedType(newValue);
  };

  useEffect(() => {
    const filteredCatProducts = productInfo.filter(
      (el) => el.category_english === selectedCategory
    );

    if (selectedCategory === "All" && selectedType === "All") {
      setFilteredProductInfo(productInfo);
    } else {
      let orderType = [];
      const TypeGroups = _.groupBy(filteredCatProducts, "type_english");
      Object.entries(TypeGroups).map(([key, value]) => {
        orderType.push(key);
      });

      setType([...orderType]);

      setFilteredProductInfo(
        productInfo.filter((el) => el.type_english === selectedType)
      );

      if (selectedType === "All") {
        setFilteredProductInfo(filteredCatProducts);
      } else {
        setFilteredProductInfo(
          filteredCatProducts.filter((el) => el.type_english === selectedType)
        );
      }
    }
  }, [selectedCategory, selectedType]);

  useEffect(() => {
    let productionAmount = 0;
    let totalSale = 0;
    let supplySale = 0;
    let fpsSale = 0;
    let otherUseAmount = 0;
    let lastDayOnHandAmount = 0;
    let todayOnHandAmount = 0;
    filteredProductInfo.map((el) => {
      console.log(el);
      productionAmount += !isNaN(el.production)
        ? el.production * parseInt(el.price)
        : 0;
      totalSale += !isNaN(el.dispatch)
        ? el.dispatch * parseInt(el.price)
        : 0 + !isNaN(el.fpsDispatch)
        ? el.fpsDispatch * parseInt(el.fair_price)
        : 0;
      supplySale += !isNaN(el.dispatch) ? el.dispatch * parseInt(el.price) : 0;
      fpsSale += !isNaN(el.fpsDispatch)
        ? el.fpsDispatch * parseInt(el.fair_price)
        : 0;
      otherUseAmount += !isNaN(el.otherUse)
        ? el.otherUse * parseInt(el.price)
        : 0;
      lastDayOnHandAmount += !isNaN(el.onHandStart)
        ? el.onHandStart * parseInt(el.price)
        : 0;
      todayOnHandAmount += !isNaN(el.onHandEnd)
        ? el.onHandEnd * parseInt(el.price)
        : 0;
    });
    setOrderDetails({
      productionAmount,
      totalSale,
      supplySale,
      fpsSale,
      otherUseAmount,
      lastDayOnHandAmount,
      todayOnHandAmount,
    });
  }, [filteredProductInfo]);

  useEffect(() => {
    callData(sortedOrdersDate[0]);
  }, []);

  return (
    <div>
      <Stack alignItems="center">
        <ReactToPrint
          trigger={() => (
            <Button
              align="center"
              sx={{
                marginBottom: 2,
                align: "center",
              }}
              variant="outlined"
            >
              Print Out
            </Button>
          )}
          content={() => componentRef.current}
        />
      </Stack>
      <Stack alignItems="center" spacing={1} marginTop="0rem">
        <Box sx={{ flexGrow: 0 }}>
          <Grid item xs={12} md={6}>
            <Card
              alignItems="start"
              sx={{
                width: "100%",
                marginTop: "0rem",
                "@media (min-width: 300px)": {
                  width: 350, // Set the width to 100% for mobile view
                },
                "@media (min-width: 650px)": {
                  width: 650, // Set the width to 650px for screens wider than 650px
                },
              }}
            >
              <CardContent>
                <Stack alignItems="center" spacing={2} justifyContent="center">
                  <label
                    style={{
                      minWidth: isMediumScreen ? "500px" : "200px",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={sortedOrdersDate}
                      sx={{
                        minWidth: isMediumScreen ? "200px" : "100px",
                        display: "flex",
                        justifyContent: "center",
                        padding: 1,
                      }}
                      value={selectedDate}
                      onChange={handleSelectDate}
                      renderInput={(params) => (
                        <TextField {...params} label="Select a date" />
                      )}
                    />

                    {/* {selectedDate && selectedCategory && (
        <Stack alignItems="center">
          <Stack
            minWidth="600px"
            sx={{ background: "#f5f5f5", padding: "1rem" }}
          ></Stack>
        </Stack>
      )} */}
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo2"
                      options={["All", ...category]}
                      sx={{
                        minWidth: isMediumScreen ? "200px" : "100px",
                        display: "flex",
                        justifyContent: "center",
                        padding: 1,
                      }}
                      value={selectedCategory}
                      onChange={handleSelectCagegory}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Category" />
                      )}
                    />

                    <Autocomplete
                      disablePortal
                      id="combo-box-demo3"
                      options={["All", ...type]}
                      sx={{
                        minWidth: isMediumScreen ? "200px" : "100px",
                        display: "flex",
                        justifyContent: "center",
                        padding: 1,
                      }}
                      value={selectedType}
                      onChange={handleSelectType}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Type" />
                      )}
                    />
                  </label>
                </Stack>

                <Stack alignItems="center">
                  <Typography
                    align="center"
                    style={{
                      fontSize: "25px",
                      fontWeight: "bold",
                      marginTop: "1rem",
                    }}
                  >
                    Daily Summary
                  </Typography>
                  <Stack
                    sx={{
                      background: "#f5f5f5",
                      padding: "1rem",
                      minWidth: isMediumScreen ? "600px" : "320px",
                    }}
                  >
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>Production </Typography>
                      <Typography>
                        {orderDetails.productionAmount.toLocaleString()}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>Total Sale </Typography>
                      <Typography>
                        {orderDetails.totalSale.toLocaleString()}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>Supply Sale</Typography>
                      <Typography>
                        {orderDetails.supplySale.toLocaleString()}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>FPS Sale</Typography>
                      <Typography>
                        {orderDetails.fpsSale.toLocaleString()}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>Other Use </Typography>
                      <Typography>
                        {orderDetails.otherUseAmount.toLocaleString()}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>Last Day On Hand </Typography>
                      <Typography>
                        {orderDetails.lastDayOnHandAmount.toLocaleString()}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>Today's On Hand </Typography>
                      <Typography>
                        {orderDetails.todayOnHandAmount.toLocaleString()}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <OverlayLoader open={openLoader} />
              </CardContent>
            </Card>
          </Grid>
        </Box>

        <Card
          variant="outlined"
          sx={{
            width: isMediumScreen ? "1000px" : "350px",
            height: isMediumScreen ? "75vh" : "50vh",
            mt: isMediumScreen ? 4 : 0,
            overflow: "auto",
            whiteSpace: "nowrap",
          }}
        >
          <CardContent>
            <TableColumnForPrint
              inputArray={filteredProductInfo}
              indexOffset={0}
              componentRef={componentRef}
            />
          </CardContent>
        </Card>
      </Stack>
    </div>
  );
}

function TableColumnForPrint({ inputArray, indexOffset, componentRef }) {

  // const componentRef = React.useRef();

  const cellStyle = {
    fontSize: "15px",
    width: 22,
    borderRight: "1px solid #f5f5f5",
    align: "center",
  };
  const headCellStyle = {
    fontSize: "16px",
    width: 22,
    borderRight: "1px solid #f5f5f5",
    align: "center",
    fontWeight: "bold",
  };
  return (
    <Table
      ref={componentRef}
      sx={{ marginTop: "2rem" }}
      aria-label="simple table"
    >
      <TableHead style={{ backgroundColor: "#f5f5f5" }}>
        <TableRow>
          <TableCell style={headCellStyle}>Name</TableCell>

          <TableCell style={headCellStyle}>Last Day On Hand</TableCell>
          <TableCell style={headCellStyle}>Today's On Hand</TableCell>
          <TableCell style={headCellStyle}>Production</TableCell>
          <TableCell style={headCellStyle}>Supply Sale</TableCell>
          <TableCell style={headCellStyle}>FPS Sale</TableCell>
          <TableCell style={headCellStyle}>Other Use</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {inputArray.map((row, index) => {
          return (
            <TableRow
              key={index}
              style={{
                fontSize: "17px",
                fontWeight: "bold",
              }}
              onClick={() => {
                // setSeletedRow(row);
                // handleOpen();
              }}
            >
              <TableCell align="center" style={cellStyle}>
                {row.name_english}
              </TableCell>
              <TableCell align="center" style={cellStyle}>
                {row.onHandStart}
              </TableCell>
              <TableCell align="center" style={cellStyle}>
                {row.onHandEnd}
              </TableCell>
              <TableCell align="center" style={cellStyle}>
                {row.production}
              </TableCell>
              <TableCell align="center" style={cellStyle}>
                {row.dispatch}
              </TableCell>
              <TableCell align="center" style={cellStyle}>
                {row.fpsDispatch}
              </TableCell>
              <TableCell align="center" style={cellStyle}>
                {row.otherUse}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
